
export const TIMEZONES = [
    {
        "value": "Europe/Podgorica",
        "label": "Europe/Podgorica (GMT+1)"
    },
    {
        "value": "Africa/Abidjan",
        "label": "Africa/Abidjan (GMT)"
    },
    {
        "value": "Africa/Accra",
        "label": "Africa/Accra (GMT)"
    },
    {
        "value": "Africa/Addis_Ababa",
        "label": "Africa/Addis_Ababa (GMT+3)"
    },
    {
        "value": "Africa/Algiers",
        "label": "Africa/Algiers (GMT+1)"
    },
    {
        "value": "Africa/Asmera",
        "label": "Africa/Asmera (GMT+3)"
    },
    {
        "value": "Africa/Bamako",
        "label": "Africa/Bamako (GMT)"
    },
    {
        "value": "Africa/Bangui",
        "label": "Africa/Bangui (GMT+1)"
    },
    {
        "value": "Africa/Banjul",
        "label": "Africa/Banjul (GMT)"
    },
    {
        "value": "Africa/Bissau",
        "label": "Africa/Bissau (GMT)"
    },
    {
        "value": "Africa/Blantyre",
        "label": "Africa/Blantyre (GMT+2)"
    },
    {
        "value": "Africa/Brazzaville",
        "label": "Africa/Brazzaville (GMT+1)"
    },
    {
        "value": "Africa/Bujumbura",
        "label": "Africa/Bujumbura (GMT+2)"
    },
    {
        "value": "Africa/Cairo",
        "label": "Africa/Cairo (GMT+2)"
    },
    {
        "value": "Africa/Casablanca",
        "label": "Africa/Casablanca (GMT)"
    },
    {
        "value": "Africa/Ceuta",
        "label": "Africa/Ceuta (GMT+1)"
    },
    {
        "value": "Africa/Conakry",
        "label": "Africa/Conakry (GMT)"
    },
    {
        "value": "Africa/Dakar",
        "label": "Africa/Dakar (GMT)"
    },
    {
        "value": "Africa/Dar_es_Salaam",
        "label": "Africa/Dar_es_Salaam (GMT+3)"
    },
    {
        "value": "Africa/Djibouti",
        "label": "Africa/Djibouti (GMT+3)"
    },
    {
        "value": "Africa/Douala",
        "label": "Africa/Douala (GMT+1)"
    },
    {
        "value": "Africa/El_Aaiun",
        "label": "Africa/El_Aaiun (GMT)"
    },
    {
        "value": "Africa/Freetown",
        "label": "Africa/Freetown (GMT)"
    },
    {
        "value": "Africa/Gaborone",
        "label": "Africa/Gaborone (GMT+2)"
    },
    {
        "value": "Africa/Harare",
        "label": "Africa/Harare (GMT+2)"
    },
    {
        "value": "Africa/Johannesburg",
        "label": "Africa/Johannesburg (GMT+2)"
    },
    {
        "value": "Africa/Juba",
        "label": "Africa/Juba (GMT+2)"
    },
    {
        "value": "Africa/Kampala",
        "label": "Africa/Kampala (GMT+3)"
    },
    {
        "value": "Africa/Khartoum",
        "label": "Africa/Khartoum (GMT+2)"
    },
    {
        "value": "Africa/Kigali",
        "label": "Africa/Kigali (GMT+2)"
    },
    {
        "value": "Africa/Kinshasa",
        "label": "Africa/Kinshasa (GMT+1)"
    },
    {
        "value": "Africa/Lagos",
        "label": "Africa/Lagos (GMT+1)"
    },
    {
        "value": "Africa/Libreville",
        "label": "Africa/Libreville (GMT+1)"
    },
    {
        "value": "Africa/Lome",
        "label": "Africa/Lome (GMT)"
    },
    {
        "value": "Africa/Luanda",
        "label": "Africa/Luanda (GMT+1)"
    },
    {
        "value": "Africa/Lubumbashi",
        "label": "Africa/Lubumbashi (GMT+2)"
    },
    {
        "value": "Africa/Lusaka",
        "label": "Africa/Lusaka (GMT+2)"
    },
    {
        "value": "Africa/Malabo",
        "label": "Africa/Malabo (GMT+1)"
    },
    {
        "value": "Africa/Maputo",
        "label": "Africa/Maputo (GMT+2)"
    },
    {
        "value": "Africa/Maseru",
        "label": "Africa/Maseru (GMT+2)"
    },
    {
        "value": "Africa/Mbabane",
        "label": "Africa/Mbabane (GMT+2)"
    },
    {
        "value": "Africa/Mogadishu",
        "label": "Africa/Mogadishu (GMT+3)"
    },
    {
        "value": "Africa/Monrovia",
        "label": "Africa/Monrovia (GMT)"
    },
    {
        "value": "Africa/Nairobi",
        "label": "Africa/Nairobi (GMT+3)"
    },
    {
        "value": "Africa/Ndjamena",
        "label": "Africa/Ndjamena (GMT+1)"
    },
    {
        "value": "Africa/Niamey",
        "label": "Africa/Niamey (GMT+1)"
    },
    {
        "value": "Africa/Nouakchott",
        "label": "Africa/Nouakchott (GMT)"
    },
    {
        "value": "Africa/Ouagadougou",
        "label": "Africa/Ouagadougou (GMT)"
    },
    {
        "value": "Africa/Porto-Novo",
        "label": "Africa/Porto-Novo (GMT+1)"
    },
    {
        "value": "Africa/Sao_Tome",
        "label": "Africa/Sao_Tome (GMT)"
    },
    {
        "value": "Africa/Tripoli",
        "label": "Africa/Tripoli (GMT+2)"
    },
    {
        "value": "Africa/Tunis",
        "label": "Africa/Tunis (GMT+1)"
    },
    {
        "value": "Africa/Windhoek",
        "label": "Africa/Windhoek (GMT+2)"
    },
    {
        "value": "America/Adak",
        "label": "America/Adak (GMT-10)"
    },
    {
        "value": "America/Anchorage",
        "label": "America/Anchorage (GMT-9)"
    },
    {
        "value": "America/Anguilla",
        "label": "America/Anguilla (GMT-4)"
    },
    {
        "value": "America/Antigua",
        "label": "America/Antigua (GMT-4)"
    },
    {
        "value": "America/Araguaina",
        "label": "America/Araguaina (BRT)"
    },
    {
        "value": "America/Argentina/La_Rioja",
        "label": "America/Argentina/La_Rioja (GMT-3)"
    },
    {
        "value": "America/Argentina/Rio_Gallegos",
        "label": "America/Argentina/Rio_Gallegos (GMT-3)"
    },
    {
        "value": "America/Argentina/Salta",
        "label": "America/Argentina/Salta (GMT-3)"
    },
    {
        "value": "America/Argentina/San_Juan",
        "label": "America/Argentina/San_Juan (GMT-3)"
    },
    {
        "value": "America/Argentina/San_Luis",
        "label": "America/Argentina/San_Luis (GMT-3)"
    },
    {
        "value": "America/Argentina/Tucuman",
        "label": "America/Argentina/Tucuman (GMT-3)"
    },
    {
        "value": "America/Argentina/Ushuaia",
        "label": "America/Argentina/Ushuaia (GMT-3)"
    },
    {
        "value": "America/Aruba",
        "label": "America/Aruba (GMT-4)"
    },
    {
        "value": "America/Asuncion",
        "label": "America/Asuncion (GMT-3)"
    },
    {
        "value": "America/Bahia",
        "label": "America/Bahia (BRT)"
    },
    {
        "value": "America/Bahia_Banderas",
        "label": "America/Bahia_Banderas (GMT-6)"
    },
    {
        "value": "America/Barbados",
        "label": "America/Barbados (GMT-4)"
    },
    {
        "value": "America/Belem",
        "label": "America/Belem (BRT)"
    },
    {
        "value": "America/Belize",
        "label": "America/Belize (GMT-6)"
    },
    {
        "value": "America/Blanc-Sablon",
        "label": "America/Blanc-Sablon (GMT-4)"
    },
    {
        "value": "America/Boa_Vista",
        "label": "America/Boa_Vista (AMT)"
    },
    {
        "value": "America/Bogota",
        "label": "America/Bogota (GMT-5)"
    },
    {
        "value": "America/Boise",
        "label": "America/Boise (GMT-7)"
    },
    {
        "value": "America/Buenos_Aires",
        "label": "America/Buenos_Aires (GMT-3)"
    },
    {
        "value": "America/Cambridge_Bay",
        "label": "America/Cambridge_Bay (GMT-7)"
    },
    {
        "value": "America/Campo_Grande",
        "label": "America/Campo_Grande (AMT)"
    },
    {
        "value": "America/Cancun",
        "label": "America/Cancun (GMT-5)"
    },
    {
        "value": "America/Caracas",
        "label": "America/Caracas (GMT-4)"
    },
    {
        "value": "America/Catamarca",
        "label": "America/Catamarca (GMT-3)"
    },
    {
        "value": "America/Cayenne",
        "label": "America/Cayenne (GMT-3)"
    },
    {
        "value": "America/Cayman",
        "label": "America/Cayman (GMT-5)"
    },
    {
        "value": "America/Chicago",
        "label": "America/Chicago (GMT-6)"
    },
    {
        "value": "America/Chihuahua",
        "label": "America/Chihuahua (GMT-6)"
    },
    {
        "value": "America/Ciudad_Juarez",
        "label": "America/Ciudad_Juarez (GMT-7)"
    },
    {
        "value": "America/Coral_Harbour",
        "label": "America/Coral_Harbour (GMT-5)"
    },
    {
        "value": "America/Cordoba",
        "label": "America/Cordoba (GMT-3)"
    },
    {
        "value": "America/Costa_Rica",
        "label": "America/Costa_Rica (GMT-6)"
    },
    {
        "value": "America/Coyhaique",
        "label": "America/Coyhaique (GMT-3)"
    },
    {
        "value": "America/Creston",
        "label": "America/Creston (GMT-7)"
    },
    {
        "value": "America/Cuiaba",
        "label": "America/Cuiaba (AMT)"
    },
    {
        "value": "America/Curacao",
        "label": "America/Curacao (GMT-4)"
    },
    {
        "value": "America/Danmarkshavn",
        "label": "America/Danmarkshavn (GMT)"
    },
    {
        "value": "America/Dawson",
        "label": "America/Dawson (GMT-7)"
    },
    {
        "value": "America/Dawson_Creek",
        "label": "America/Dawson_Creek (GMT-7)"
    },
    {
        "value": "America/Denver",
        "label": "America/Denver (GMT-7)"
    },
    {
        "value": "America/Detroit",
        "label": "America/Detroit (GMT-5)"
    },
    {
        "value": "America/Dominica",
        "label": "America/Dominica (GMT-4)"
    },
    {
        "value": "America/Edmonton",
        "label": "America/Edmonton (GMT-7)"
    },
    {
        "value": "America/Eirunepe",
        "label": "America/Eirunepe (ACT)"
    },
    {
        "value": "America/El_Salvador",
        "label": "America/El_Salvador (GMT-6)"
    },
    {
        "value": "America/Fort_Nelson",
        "label": "America/Fort_Nelson (GMT-7)"
    },
    {
        "value": "America/Fortaleza",
        "label": "America/Fortaleza (BRT)"
    },
    {
        "value": "America/Glace_Bay",
        "label": "America/Glace_Bay (GMT-4)"
    },
    {
        "value": "America/Godthab",
        "label": "America/Godthab (GMT-2)"
    },
    {
        "value": "America/Goose_Bay",
        "label": "America/Goose_Bay (GMT-4)"
    },
    {
        "value": "America/Grand_Turk",
        "label": "America/Grand_Turk (GMT-5)"
    },
    {
        "value": "America/Grenada",
        "label": "America/Grenada (GMT-4)"
    },
    {
        "value": "America/Guadeloupe",
        "label": "America/Guadeloupe (GMT-4)"
    },
    {
        "value": "America/Guatemala",
        "label": "America/Guatemala (GMT-6)"
    },
    {
        "value": "America/Guayaquil",
        "label": "America/Guayaquil (GMT-5)"
    },
    {
        "value": "America/Guyana",
        "label": "America/Guyana (GMT-4)"
    },
    {
        "value": "America/Halifax",
        "label": "America/Halifax (GMT-4)"
    },
    {
        "value": "America/Havana",
        "label": "America/Havana (GMT-5)"
    },
    {
        "value": "America/Hermosillo",
        "label": "America/Hermosillo (GMT-7)"
    },
    {
        "value": "America/Indiana/Knox",
        "label": "America/Indiana/Knox (GMT-6)"
    },
    {
        "value": "America/Indiana/Marengo",
        "label": "America/Indiana/Marengo (GMT-5)"
    },
    {
        "value": "America/Indiana/Petersburg",
        "label": "America/Indiana/Petersburg (GMT-5)"
    },
    {
        "value": "America/Indiana/Tell_City",
        "label": "America/Indiana/Tell_City (GMT-6)"
    },
    {
        "value": "America/Indiana/Vevay",
        "label": "America/Indiana/Vevay (GMT-5)"
    },
    {
        "value": "America/Indiana/Vincennes",
        "label": "America/Indiana/Vincennes (GMT-5)"
    },
    {
        "value": "America/Indiana/Winamac",
        "label": "America/Indiana/Winamac (GMT-5)"
    },
    {
        "value": "America/Indianapolis",
        "label": "America/Indianapolis (GMT-5)"
    },
    {
        "value": "America/Inuvik",
        "label": "America/Inuvik (GMT-7)"
    },
    {
        "value": "America/Iqaluit",
        "label": "America/Iqaluit (GMT-5)"
    },
    {
        "value": "America/Jamaica",
        "label": "America/Jamaica (GMT-5)"
    },
    {
        "value": "America/Jujuy",
        "label": "America/Jujuy (GMT-3)"
    },
    {
        "value": "America/Juneau",
        "label": "America/Juneau (GMT-9)"
    },
    {
        "value": "America/Kentucky/Monticello",
        "label": "America/Kentucky/Monticello (GMT-5)"
    },
    {
        "value": "America/Kralendijk",
        "label": "America/Kralendijk (GMT-4)"
    },
    {
        "value": "America/La_Paz",
        "label": "America/La_Paz (GMT-4)"
    },
    {
        "value": "America/Lima",
        "label": "America/Lima (GMT-5)"
    },
    {
        "value": "America/Los_Angeles",
        "label": "America/Los_Angeles (GMT-8)"
    },
    {
        "value": "America/Louisville",
        "label": "America/Louisville (GMT-5)"
    },
    {
        "value": "America/Lower_Princes",
        "label": "America/Lower_Princes (GMT-4)"
    },
    {
        "value": "America/Maceio",
        "label": "America/Maceio (BRT)"
    },
    {
        "value": "America/Managua",
        "label": "America/Managua (GMT-6)"
    },
    {
        "value": "America/Manaus",
        "label": "America/Manaus (AMT)"
    },
    {
        "value": "America/Marigot",
        "label": "America/Marigot (GMT-4)"
    },
    {
        "value": "America/Martinique",
        "label": "America/Martinique (GMT-4)"
    },
    {
        "value": "America/Matamoros",
        "label": "America/Matamoros (GMT-6)"
    },
    {
        "value": "America/Mazatlan",
        "label": "America/Mazatlan (GMT-7)"
    },
    {
        "value": "America/Mendoza",
        "label": "America/Mendoza (GMT-3)"
    },
    {
        "value": "America/Menominee",
        "label": "America/Menominee (GMT-6)"
    },
    {
        "value": "America/Merida",
        "label": "America/Merida (GMT-6)"
    },
    {
        "value": "America/Metlakatla",
        "label": "America/Metlakatla (GMT-9)"
    },
    {
        "value": "America/Mexico_City",
        "label": "America/Mexico_City (GMT-6)"
    },
    {
        "value": "America/Miquelon",
        "label": "America/Miquelon (GMT-3)"
    },
    {
        "value": "America/Moncton",
        "label": "America/Moncton (GMT-4)"
    },
    {
        "value": "America/Monterrey",
        "label": "America/Monterrey (GMT-6)"
    },
    {
        "value": "America/Montevideo",
        "label": "America/Montevideo (GMT-3)"
    },
    {
        "value": "America/Montserrat",
        "label": "America/Montserrat (GMT-4)"
    },
    {
        "value": "America/Nassau",
        "label": "America/Nassau (GMT-5)"
    },
    {
        "value": "America/New_York",
        "label": "America/New_York (GMT-5)"
    },
    {
        "value": "America/Nome",
        "label": "America/Nome (GMT-9)"
    },
    {
        "value": "America/Noronha",
        "label": "America/Noronha (GMT-2)"
    },
    {
        "value": "America/North_Dakota/Beulah",
        "label": "America/North_Dakota/Beulah (GMT-6)"
    },
    {
        "value": "America/North_Dakota/Center",
        "label": "America/North_Dakota/Center (GMT-6)"
    },
    {
        "value": "America/North_Dakota/New_Salem",
        "label": "America/North_Dakota/New_Salem (GMT-6)"
    },
    {
        "value": "America/Ojinaga",
        "label": "America/Ojinaga (GMT-6)"
    },
    {
        "value": "America/Panama",
        "label": "America/Panama (GMT-5)"
    },
    {
        "value": "America/Paramaribo",
        "label": "America/Paramaribo (GMT-3)"
    },
    {
        "value": "America/Phoenix",
        "label": "America/Phoenix (GMT-7)"
    },
    {
        "value": "America/Port_of_Spain",
        "label": "America/Port_of_Spain (GMT-4)"
    },
    {
        "value": "America/Port-au-Prince",
        "label": "America/Port-au-Prince (GMT-5)"
    },
    {
        "value": "America/Porto_Velho",
        "label": "America/Porto_Velho (AMT)"
    },
    {
        "value": "America/Puerto_Rico",
        "label": "America/Puerto_Rico (GMT-4)"
    },
    {
        "value": "America/Punta_Arenas",
        "label": "America/Punta_Arenas (GMT-3)"
    },
    {
        "value": "America/Rankin_Inlet",
        "label": "America/Rankin_Inlet (GMT-6)"
    },
    {
        "value": "America/Recife",
        "label": "America/Recife (BRT)"
    },
    {
        "value": "America/Regina",
        "label": "America/Regina (GMT-6)"
    },
    {
        "value": "America/Resolute",
        "label": "America/Resolute (GMT-6)"
    },
    {
        "value": "America/Rio_Branco",
        "label": "America/Rio_Branco (ACT)"
    },
    {
        "value": "America/Santarem",
        "label": "America/Santarem (BRT)"
    },
    {
        "value": "America/Santiago",
        "label": "America/Santiago (GMT-3)"
    },
    {
        "value": "America/Santo_Domingo",
        "label": "America/Santo_Domingo (GMT-4)"
    },
    {
        "value": "America/Sao_Paulo",
        "label": "America/Sao_Paulo (BRT)"
    },
    {
        "value": "America/Scoresbysund",
        "label": "America/Scoresbysund (GMT-2)"
    },
    {
        "value": "America/Sitka",
        "label": "America/Sitka (GMT-9)"
    },
    {
        "value": "America/St_Barthelemy",
        "label": "America/St_Barthelemy (GMT-4)"
    },
    {
        "value": "America/St_Johns",
        "label": "America/St_Johns (GMT-3:30)"
    },
    {
        "value": "America/St_Kitts",
        "label": "America/St_Kitts (GMT-4)"
    },
    {
        "value": "America/St_Lucia",
        "label": "America/St_Lucia (GMT-4)"
    },
    {
        "value": "America/St_Thomas",
        "label": "America/St_Thomas (GMT-4)"
    },
    {
        "value": "America/St_Vincent",
        "label": "America/St_Vincent (GMT-4)"
    },
    {
        "value": "America/Swift_Current",
        "label": "America/Swift_Current (GMT-6)"
    },
    {
        "value": "America/Tegucigalpa",
        "label": "America/Tegucigalpa (GMT-6)"
    },
    {
        "value": "America/Thule",
        "label": "America/Thule (GMT-4)"
    },
    {
        "value": "America/Tijuana",
        "label": "America/Tijuana (GMT-8)"
    },
    {
        "value": "America/Toronto",
        "label": "America/Toronto (GMT-5)"
    },
    {
        "value": "America/Tortola",
        "label": "America/Tortola (GMT-4)"
    },
    {
        "value": "America/Vancouver",
        "label": "America/Vancouver (GMT-8)"
    },
    {
        "value": "America/Whitehorse",
        "label": "America/Whitehorse (GMT-7)"
    },
    {
        "value": "America/Winnipeg",
        "label": "America/Winnipeg (GMT-6)"
    },
    {
        "value": "America/Yakutat",
        "label": "America/Yakutat (GMT-9)"
    },
    {
        "value": "Antarctica/Casey",
        "label": "Antarctica/Casey (GMT+8)"
    },
    {
        "value": "Antarctica/Davis",
        "label": "Antarctica/Davis (GMT+7)"
    },
    {
        "value": "Antarctica/DumontDUrville",
        "label": "Antarctica/DumontDUrville (GMT+10)"
    },
    {
        "value": "Antarctica/Macquarie",
        "label": "Antarctica/Macquarie (GMT+11)"
    },
    {
        "value": "Antarctica/Mawson",
        "label": "Antarctica/Mawson (GMT+5)"
    },
    {
        "value": "Antarctica/McMurdo",
        "label": "Antarctica/McMurdo (GMT+13)"
    },
    {
        "value": "Antarctica/Palmer",
        "label": "Antarctica/Palmer (GMT-3)"
    },
    {
        "value": "Antarctica/Rothera",
        "label": "Antarctica/Rothera (GMT-3)"
    },
    {
        "value": "Antarctica/Syowa",
        "label": "Antarctica/Syowa (GMT+3)"
    },
    {
        "value": "Antarctica/Troll",
        "label": "Antarctica/Troll (GMT)"
    },
    {
        "value": "Antarctica/Vostok",
        "label": "Antarctica/Vostok (GMT+5)"
    },
    {
        "value": "Arctic/Longyearbyen",
        "label": "Arctic/Longyearbyen (GMT+1)"
    },
    {
        "value": "Asia/Aden",
        "label": "Asia/Aden (GMT+3)"
    },
    {
        "value": "Asia/Almaty",
        "label": "Asia/Almaty (GMT+5)"
    },
    {
        "value": "Asia/Amman",
        "label": "Asia/Amman (GMT+3)"
    },
    {
        "value": "Asia/Anadyr",
        "label": "Asia/Anadyr (GMT+12)"
    },
    {
        "value": "Asia/Aqtau",
        "label": "Asia/Aqtau (GMT+5)"
    },
    {
        "value": "Asia/Aqtobe",
        "label": "Asia/Aqtobe (GMT+5)"
    },
    {
        "value": "Asia/Ashgabat",
        "label": "Asia/Ashgabat (GMT+5)"
    },
    {
        "value": "Asia/Atyrau",
        "label": "Asia/Atyrau (GMT+5)"
    },
    {
        "value": "Asia/Baghdad",
        "label": "Asia/Baghdad (GMT+3)"
    },
    {
        "value": "Asia/Bahrain",
        "label": "Asia/Bahrain (GMT+3)"
    },
    {
        "value": "Asia/Baku",
        "label": "Asia/Baku (GMT+4)"
    },
    {
        "value": "Asia/Bangkok",
        "label": "Asia/Bangkok (GMT+7)"
    },
    {
        "value": "Asia/Barnaul",
        "label": "Asia/Barnaul (GMT+7)"
    },
    {
        "value": "Asia/Beirut",
        "label": "Asia/Beirut (GMT+2)"
    },
    {
        "value": "Asia/Bishkek",
        "label": "Asia/Bishkek (GMT+6)"
    },
    {
        "value": "Asia/Brunei",
        "label": "Asia/Brunei (GMT+8)"
    },
    {
        "value": "Asia/Calcutta",
        "label": "Asia/Calcutta (GMT+5:30)"
    },
    {
        "value": "Asia/Chita",
        "label": "Asia/Chita (GMT+9)"
    },
    {
        "value": "Asia/Colombo",
        "label": "Asia/Colombo (GMT+5:30)"
    },
    {
        "value": "Asia/Damascus",
        "label": "Asia/Damascus (GMT+3)"
    },
    {
        "value": "Asia/Dhaka",
        "label": "Asia/Dhaka (GMT+6)"
    },
    {
        "value": "Asia/Dili",
        "label": "Asia/Dili (GMT+9)"
    },
    {
        "value": "Asia/Dubai",
        "label": "Asia/Dubai (GMT+4)"
    },
    {
        "value": "Asia/Dushanbe",
        "label": "Asia/Dushanbe (GMT+5)"
    },
    {
        "value": "Asia/Famagusta",
        "label": "Asia/Famagusta (GMT+2)"
    },
    {
        "value": "Asia/Gaza",
        "label": "Asia/Gaza (GMT+2)"
    },
    {
        "value": "Asia/Hebron",
        "label": "Asia/Hebron (GMT+2)"
    },
    {
        "value": "Asia/Hong_Kong",
        "label": "Asia/Hong_Kong (GMT+8)"
    },
    {
        "value": "Asia/Hovd",
        "label": "Asia/Hovd (GMT+7)"
    },
    {
        "value": "Asia/Irkutsk",
        "label": "Asia/Irkutsk (GMT+8)"
    },
    {
        "value": "Asia/Jakarta",
        "label": "Asia/Jakarta (GMT+7)"
    },
    {
        "value": "Asia/Jayapura",
        "label": "Asia/Jayapura (GMT+9)"
    },
    {
        "value": "Asia/Jerusalem",
        "label": "Asia/Jerusalem (GMT+2)"
    },
    {
        "value": "Asia/Kabul",
        "label": "Asia/Kabul (GMT+4:30)"
    },
    {
        "value": "Asia/Kamchatka",
        "label": "Asia/Kamchatka (GMT+12)"
    },
    {
        "value": "Asia/Karachi",
        "label": "Asia/Karachi (GMT+5)"
    },
    {
        "value": "Asia/Katmandu",
        "label": "Asia/Katmandu (GMT+5:45)"
    },
    {
        "value": "Asia/Khandyga",
        "label": "Asia/Khandyga (GMT+9)"
    },
    {
        "value": "Asia/Krasnoyarsk",
        "label": "Asia/Krasnoyarsk (GMT+7)"
    },
    {
        "value": "Asia/Kuala_Lumpur",
        "label": "Asia/Kuala_Lumpur (GMT+8)"
    },
    {
        "value": "Asia/Kuching",
        "label": "Asia/Kuching (GMT+8)"
    },
    {
        "value": "Asia/Kuwait",
        "label": "Asia/Kuwait (GMT+3)"
    },
    {
        "value": "Asia/Macau",
        "label": "Asia/Macau (GMT+8)"
    },
    {
        "value": "Asia/Magadan",
        "label": "Asia/Magadan (GMT+11)"
    },
    {
        "value": "Asia/Makassar",
        "label": "Asia/Makassar (GMT+8)"
    },
    {
        "value": "Asia/Manila",
        "label": "Asia/Manila (GMT+8)"
    },
    {
        "value": "Asia/Muscat",
        "label": "Asia/Muscat (GMT+4)"
    },
    {
        "value": "Asia/Nicosia",
        "label": "Asia/Nicosia (GMT+2)"
    },
    {
        "value": "Asia/Novokuznetsk",
        "label": "Asia/Novokuznetsk (GMT+7)"
    },
    {
        "value": "Asia/Novosibirsk",
        "label": "Asia/Novosibirsk (GMT+7)"
    },
    {
        "value": "Asia/Omsk",
        "label": "Asia/Omsk (GMT+6)"
    },
    {
        "value": "Asia/Oral",
        "label": "Asia/Oral (GMT+5)"
    },
    {
        "value": "Asia/Phnom_Penh",
        "label": "Asia/Phnom_Penh (GMT+7)"
    },
    {
        "value": "Asia/Pontianak",
        "label": "Asia/Pontianak (GMT+7)"
    },
    {
        "value": "Asia/Pyongyang",
        "label": "Asia/Pyongyang (GMT+9)"
    },
    {
        "value": "Asia/Qatar",
        "label": "Asia/Qatar (GMT+3)"
    },
    {
        "value": "Asia/Qostanay",
        "label": "Asia/Qostanay (GMT+5)"
    },
    {
        "value": "Asia/Qyzylorda",
        "label": "Asia/Qyzylorda (GMT+5)"
    },
    {
        "value": "Asia/Rangoon",
        "label": "Asia/Rangoon (GMT+6:30)"
    },
    {
        "value": "Asia/Riyadh",
        "label": "Asia/Riyadh (GMT+3)"
    },
    {
        "value": "Asia/Saigon",
        "label": "Asia/Saigon (GMT+7)"
    },
    {
        "value": "Asia/Sakhalin",
        "label": "Asia/Sakhalin (GMT+11)"
    },
    {
        "value": "Asia/Samarkand",
        "label": "Asia/Samarkand (GMT+5)"
    },
    {
        "value": "Asia/Seoul",
        "label": "Asia/Seoul (GMT+9)"
    },
    {
        "value": "Asia/Shanghai",
        "label": "Asia/Shanghai (GMT+8)"
    },
    {
        "value": "Asia/Singapore",
        "label": "Asia/Singapore (GMT+8)"
    },
    {
        "value": "Asia/Srednekolymsk",
        "label": "Asia/Srednekolymsk (GMT+11)"
    },
    {
        "value": "Asia/Taipei",
        "label": "Asia/Taipei (GMT+8)"
    },
    {
        "value": "Asia/Tashkent",
        "label": "Asia/Tashkent (GMT+5)"
    },
    {
        "value": "Asia/Tbilisi",
        "label": "Asia/Tbilisi (GMT+4)"
    },
    {
        "value": "Asia/Tehran",
        "label": "Asia/Tehran (GMT+3:30)"
    },
    {
        "value": "Asia/Thimphu",
        "label": "Asia/Thimphu (GMT+6)"
    },
    {
        "value": "Asia/Tokyo",
        "label": "Asia/Tokyo (GMT+9)"
    },
    {
        "value": "Asia/Tomsk",
        "label": "Asia/Tomsk (GMT+7)"
    },
    {
        "value": "Asia/Ulaanbaatar",
        "label": "Asia/Ulaanbaatar (GMT+8)"
    },
    {
        "value": "Asia/Urumqi",
        "label": "Asia/Urumqi (GMT+6)"
    },
    {
        "value": "Asia/Ust-Nera",
        "label": "Asia/Ust-Nera (GMT+10)"
    },
    {
        "value": "Asia/Vientiane",
        "label": "Asia/Vientiane (GMT+7)"
    },
    {
        "value": "Asia/Vladivostok",
        "label": "Asia/Vladivostok (GMT+10)"
    },
    {
        "value": "Asia/Yakutsk",
        "label": "Asia/Yakutsk (GMT+9)"
    },
    {
        "value": "Asia/Yekaterinburg",
        "label": "Asia/Yekaterinburg (GMT+5)"
    },
    {
        "value": "Asia/Yerevan",
        "label": "Asia/Yerevan (GMT+4)"
    },
    {
        "value": "Atlantic/Azores",
        "label": "Atlantic/Azores (GMT-1)"
    },
    {
        "value": "Atlantic/Bermuda",
        "label": "Atlantic/Bermuda (GMT-4)"
    },
    {
        "value": "Atlantic/Canary",
        "label": "Atlantic/Canary (GMT)"
    },
    {
        "value": "Atlantic/Cape_Verde",
        "label": "Atlantic/Cape_Verde (GMT-1)"
    },
    {
        "value": "Atlantic/Faeroe",
        "label": "Atlantic/Faeroe (GMT)"
    },
    {
        "value": "Atlantic/Madeira",
        "label": "Atlantic/Madeira (GMT)"
    },
    {
        "value": "Atlantic/Reykjavik",
        "label": "Atlantic/Reykjavik (GMT)"
    },
    {
        "value": "Atlantic/South_Georgia",
        "label": "Atlantic/South_Georgia (GMT-2)"
    },
    {
        "value": "Atlantic/St_Helena",
        "label": "Atlantic/St_Helena (GMT)"
    },
    {
        "value": "Atlantic/Stanley",
        "label": "Atlantic/Stanley (GMT-3)"
    },
    {
        "value": "Australia/Adelaide",
        "label": "Australia/Adelaide (GMT+10:30)"
    },
    {
        "value": "Australia/Brisbane",
        "label": "Australia/Brisbane (GMT+10)"
    },
    {
        "value": "Australia/Broken_Hill",
        "label": "Australia/Broken_Hill (GMT+10:30)"
    },
    {
        "value": "Australia/Darwin",
        "label": "Australia/Darwin (GMT+9:30)"
    },
    {
        "value": "Australia/Eucla",
        "label": "Australia/Eucla (GMT+8:45)"
    },
    {
        "value": "Australia/Hobart",
        "label": "Australia/Hobart (GMT+11)"
    },
    {
        "value": "Australia/Lindeman",
        "label": "Australia/Lindeman (GMT+10)"
    },
    {
        "value": "Australia/Lord_Howe",
        "label": "Australia/Lord_Howe (GMT+11)"
    },
    {
        "value": "Australia/Melbourne",
        "label": "Australia/Melbourne (GMT+11)"
    },
    {
        "value": "Australia/Perth",
        "label": "Australia/Perth (GMT+8)"
    },
    {
        "value": "Australia/Sydney",
        "label": "Australia/Sydney (GMT+11)"
    },
    {
        "value": "Europe/Amsterdam",
        "label": "Europe/Amsterdam (GMT+1)"
    },
    {
        "value": "Europe/Andorra",
        "label": "Europe/Andorra (GMT+1)"
    },
    {
        "value": "Europe/Astrakhan",
        "label": "Europe/Astrakhan (GMT+4)"
    },
    {
        "value": "Europe/Athens",
        "label": "Europe/Athens (GMT+2)"
    },
    {
        "value": "Europe/Belgrade",
        "label": "Europe/Belgrade (GMT+1)"
    },
    {
        "value": "Europe/Berlin",
        "label": "Europe/Berlin (GMT+1)"
    },
    {
        "value": "Europe/Bratislava",
        "label": "Europe/Bratislava (GMT+1)"
    },
    {
        "value": "Europe/Brussels",
        "label": "Europe/Brussels (GMT+1)"
    },
    {
        "value": "Europe/Bucharest",
        "label": "Europe/Bucharest (GMT+2)"
    },
    {
        "value": "Europe/Budapest",
        "label": "Europe/Budapest (GMT+1)"
    },
    {
        "value": "Europe/Busingen",
        "label": "Europe/Busingen (GMT+1)"
    },
    {
        "value": "Europe/Chisinau",
        "label": "Europe/Chisinau (GMT+2)"
    },
    {
        "value": "Europe/Copenhagen",
        "label": "Europe/Copenhagen (GMT+1)"
    },
    {
        "value": "Europe/Dublin",
        "label": "Europe/Dublin (GMT)"
    },
    {
        "value": "Europe/Gibraltar",
        "label": "Europe/Gibraltar (GMT+1)"
    },
    {
        "value": "Europe/Guernsey",
        "label": "Europe/Guernsey (GMT)"
    },
    {
        "value": "Europe/Helsinki",
        "label": "Europe/Helsinki (GMT+2)"
    },
    {
        "value": "Europe/Isle_of_Man",
        "label": "Europe/Isle_of_Man (GMT)"
    },
    {
        "value": "Europe/Istanbul",
        "label": "Europe/Istanbul (GMT+3)"
    },
    {
        "value": "Europe/Jersey",
        "label": "Europe/Jersey (GMT)"
    },
    {
        "value": "Europe/Kaliningrad",
        "label": "Europe/Kaliningrad (GMT+2)"
    },
    {
        "value": "Europe/Kiev",
        "label": "Europe/Kiev (GMT+2)"
    },
    {
        "value": "Europe/Kirov",
        "label": "Europe/Kirov (GMT+3)"
    },
    {
        "value": "Europe/Lisbon",
        "label": "Europe/Lisbon (GMT)"
    },
    {
        "value": "Europe/Ljubljana",
        "label": "Europe/Ljubljana (GMT+1)"
    },
    {
        "value": "Europe/London",
        "label": "Europe/London (GMT)"
    },
    {
        "value": "Europe/Luxembourg",
        "label": "Europe/Luxembourg (GMT+1)"
    },
    {
        "value": "Europe/Madrid",
        "label": "Europe/Madrid (GMT+1)"
    },
    {
        "value": "Europe/Malta",
        "label": "Europe/Malta (GMT+1)"
    },
    {
        "value": "Europe/Mariehamn",
        "label": "Europe/Mariehamn (GMT+2)"
    },
    {
        "value": "Europe/Minsk",
        "label": "Europe/Minsk (GMT+3)"
    },
    {
        "value": "Europe/Monaco",
        "label": "Europe/Monaco (GMT+1)"
    },
    {
        "value": "Europe/Moscow",
        "label": "Europe/Moscow (GMT+3)"
    },
    {
        "value": "Europe/Oslo",
        "label": "Europe/Oslo (GMT+1)"
    },
    {
        "value": "Europe/Paris",
        "label": "Europe/Paris (GMT+1)"
    },
    {
        "value": "Europe/Podgorica",
        "label": "Europe/Podgorica (GMT+1)"
    },
    {
        "value": "Europe/Prague",
        "label": "Europe/Prague (GMT+1)"
    },
    {
        "value": "Europe/Riga",
        "label": "Europe/Riga (GMT+2)"
    },
    {
        "value": "Europe/Rome",
        "label": "Europe/Rome (GMT+1)"
    },
    {
        "value": "Europe/Samara",
        "label": "Europe/Samara (GMT+4)"
    },
    {
        "value": "Europe/San_Marino",
        "label": "Europe/San_Marino (GMT+1)"
    },
    {
        "value": "Europe/Sarajevo",
        "label": "Europe/Sarajevo (GMT+1)"
    },
    {
        "value": "Europe/Saratov",
        "label": "Europe/Saratov (GMT+4)"
    },
    {
        "value": "Europe/Simferopol",
        "label": "Europe/Simferopol (GMT+3)"
    },
    {
        "value": "Europe/Skopje",
        "label": "Europe/Skopje (GMT+1)"
    },
    {
        "value": "Europe/Sofia",
        "label": "Europe/Sofia (GMT+2)"
    },
    {
        "value": "Europe/Stockholm",
        "label": "Europe/Stockholm (GMT+1)"
    },
    {
        "value": "Europe/Tallinn",
        "label": "Europe/Tallinn (GMT+2)"
    },
    {
        "value": "Europe/Tirane",
        "label": "Europe/Tirane (GMT+1)"
    },
    {
        "value": "Europe/Ulyanovsk",
        "label": "Europe/Ulyanovsk (GMT+4)"
    },
    {
        "value": "Europe/Vaduz",
        "label": "Europe/Vaduz (GMT+1)"
    },
    {
        "value": "Europe/Vatican",
        "label": "Europe/Vatican (GMT+1)"
    },
    {
        "value": "Europe/Vienna",
        "label": "Europe/Vienna (GMT+1)"
    },
    {
        "value": "Europe/Vilnius",
        "label": "Europe/Vilnius (GMT+2)"
    },
    {
        "value": "Europe/Volgograd",
        "label": "Europe/Volgograd (GMT+3)"
    },
    {
        "value": "Europe/Warsaw",
        "label": "Europe/Warsaw (GMT+1)"
    },
    {
        "value": "Europe/Zagreb",
        "label": "Europe/Zagreb (GMT+1)"
    },
    {
        "value": "Europe/Zurich",
        "label": "Europe/Zurich (GMT+1)"
    },
    {
        "value": "Indian/Antananarivo",
        "label": "Indian/Antananarivo (GMT+3)"
    },
    {
        "value": "Indian/Chagos",
        "label": "Indian/Chagos (GMT+6)"
    },
    {
        "value": "Indian/Christmas",
        "label": "Indian/Christmas (GMT+7)"
    },
    {
        "value": "Indian/Cocos",
        "label": "Indian/Cocos (GMT+6:30)"
    },
    {
        "value": "Indian/Comoro",
        "label": "Indian/Comoro (GMT+3)"
    },
    {
        "value": "Indian/Kerguelen",
        "label": "Indian/Kerguelen (GMT+5)"
    },
    {
        "value": "Indian/Mahe",
        "label": "Indian/Mahe (GMT+4)"
    },
    {
        "value": "Indian/Maldives",
        "label": "Indian/Maldives (GMT+5)"
    },
    {
        "value": "Indian/Mauritius",
        "label": "Indian/Mauritius (GMT+4)"
    },
    {
        "value": "Indian/Mayotte",
        "label": "Indian/Mayotte (GMT+3)"
    },
    {
        "value": "Indian/Reunion",
        "label": "Indian/Reunion (GMT+4)"
    },
    {
        "value": "Pacific/Apia",
        "label": "Pacific/Apia (GMT+13)"
    },
    {
        "value": "Pacific/Auckland",
        "label": "Pacific/Auckland (GMT+13)"
    },
    {
        "value": "Pacific/Bougainville",
        "label": "Pacific/Bougainville (GMT+11)"
    },
    {
        "value": "Pacific/Chatham",
        "label": "Pacific/Chatham (GMT+13:45)"
    },
    {
        "value": "Pacific/Easter",
        "label": "Pacific/Easter (GMT-5)"
    },
    {
        "value": "Pacific/Efate",
        "label": "Pacific/Efate (GMT+11)"
    },
    {
        "value": "Pacific/Enderbury",
        "label": "Pacific/Enderbury (GMT+13)"
    },
    {
        "value": "Pacific/Fakaofo",
        "label": "Pacific/Fakaofo (GMT+13)"
    },
    {
        "value": "Pacific/Fiji",
        "label": "Pacific/Fiji (GMT+12)"
    },
    {
        "value": "Pacific/Funafuti",
        "label": "Pacific/Funafuti (GMT+12)"
    },
    {
        "value": "Pacific/Galapagos",
        "label": "Pacific/Galapagos (GMT-6)"
    },
    {
        "value": "Pacific/Gambier",
        "label": "Pacific/Gambier (GMT-9)"
    },
    {
        "value": "Pacific/Guadalcanal",
        "label": "Pacific/Guadalcanal (GMT+11)"
    },
    {
        "value": "Pacific/Guam",
        "label": "Pacific/Guam (GMT+10)"
    },
    {
        "value": "Pacific/Honolulu",
        "label": "Pacific/Honolulu (GMT-10)"
    },
    {
        "value": "Pacific/Kiritimati",
        "label": "Pacific/Kiritimati (GMT+14)"
    },
    {
        "value": "Pacific/Kosrae",
        "label": "Pacific/Kosrae (GMT+11)"
    },
    {
        "value": "Pacific/Kwajalein",
        "label": "Pacific/Kwajalein (GMT+12)"
    },
    {
        "value": "Pacific/Majuro",
        "label": "Pacific/Majuro (GMT+12)"
    },
    {
        "value": "Pacific/Marquesas",
        "label": "Pacific/Marquesas (GMT-9:30)"
    },
    {
        "value": "Pacific/Midway",
        "label": "Pacific/Midway (GMT-11)"
    },
    {
        "value": "Pacific/Nauru",
        "label": "Pacific/Nauru (GMT+12)"
    },
    {
        "value": "Pacific/Niue",
        "label": "Pacific/Niue (GMT-11)"
    },
    {
        "value": "Pacific/Norfolk",
        "label": "Pacific/Norfolk (GMT+12)"
    },
    {
        "value": "Pacific/Noumea",
        "label": "Pacific/Noumea (GMT+11)"
    },
    {
        "value": "Pacific/Pago_Pago",
        "label": "Pacific/Pago_Pago (GMT-11)"
    },
    {
        "value": "Pacific/Palau",
        "label": "Pacific/Palau (GMT+9)"
    },
    {
        "value": "Pacific/Pitcairn",
        "label": "Pacific/Pitcairn (GMT-8)"
    },
    {
        "value": "Pacific/Ponape",
        "label": "Pacific/Ponape (GMT+11)"
    },
    {
        "value": "Pacific/Port_Moresby",
        "label": "Pacific/Port_Moresby (GMT+10)"
    },
    {
        "value": "Pacific/Rarotonga",
        "label": "Pacific/Rarotonga (GMT-10)"
    },
    {
        "value": "Pacific/Saipan",
        "label": "Pacific/Saipan (GMT+10)"
    },
    {
        "value": "Pacific/Tahiti",
        "label": "Pacific/Tahiti (GMT-10)"
    },
    {
        "value": "Pacific/Tarawa",
        "label": "Pacific/Tarawa (GMT+12)"
    },
    {
        "value": "Pacific/Tongatapu",
        "label": "Pacific/Tongatapu (GMT+13)"
    },
    {
        "value": "Pacific/Truk",
        "label": "Pacific/Truk (GMT+10)"
    },
    {
        "value": "Pacific/Wake",
        "label": "Pacific/Wake (GMT+12)"
    },
    {
        "value": "Pacific/Wallis",
        "label": "Pacific/Wallis (GMT+12)"
    }
];

export const LANGUAGES = [
    {
        "value": "Francês - França",
        "label": "Francês - França"
    },
    {
        "value": "Africâner - África do Sul",
        "label": "Africâner - África do Sul"
    },
    {
        "value": "Albanês - Albânia",
        "label": "Albanês - Albânia"
    },
    {
        "value": "Alemão - Alemanha",
        "label": "Alemão - Alemanha"
    },
    {
        "value": "Alemão - Áustria",
        "label": "Alemão - Áustria"
    },
    {
        "value": "Alemão - Luxemburgo",
        "label": "Alemão - Luxemburgo"
    },
    {
        "value": "Alto alemão - Suíça",
        "label": "Alto alemão - Suíça"
    },
    {
        "value": "Amárico - Etiópia",
        "label": "Amárico - Etiópia"
    },
    {
        "value": "Árabe - Arábia Saudita",
        "label": "Árabe - Arábia Saudita"
    },
    {
        "value": "Árabe - Argélia",
        "label": "Árabe - Argélia"
    },
    {
        "value": "Árabe - Barein",
        "label": "Árabe - Barein"
    },
    {
        "value": "Árabe - Catar",
        "label": "Árabe - Catar"
    },
    {
        "value": "Árabe - Egito",
        "label": "Árabe - Egito"
    },
    {
        "value": "Árabe - Emirados Árabes Unidos",
        "label": "Árabe - Emirados Árabes Unidos"
    },
    {
        "value": "Árabe - Kuwait",
        "label": "Árabe - Kuwait"
    },
    {
        "value": "Árabe - Líbano",
        "label": "Árabe - Líbano"
    },
    {
        "value": "Árabe - Marrocos",
        "label": "Árabe - Marrocos"
    },
    {
        "value": "Árabe - Omã",
        "label": "Árabe - Omã"
    },
    {
        "value": "Árabe - Tunísia",
        "label": "Árabe - Tunísia"
    },
    {
        "value": "Armênio - Armênia",
        "label": "Armênio - Armênia"
    },
    {
        "value": "Azerbaijano - Azerbaijão",
        "label": "Azerbaijano - Azerbaijão"
    },
    {
        "value": "Basco - Espanha",
        "label": "Basco - Espanha"
    },
    {
        "value": "Bengali - Bangladesh",
        "label": "Bengali - Bangladesh"
    },
    {
        "value": "Bengali - Índia",
        "label": "Bengali - Índia"
    },
    {
        "value": "Bielorrusso - Bielorrússia",
        "label": "Bielorrusso - Bielorrússia"
    },
    {
        "value": "Birmanês - Mianmar [Birmânia]",
        "label": "Birmanês - Mianmar [Birmânia]"
    },
    {
        "value": "Bokmål norueguês - Noruega",
        "label": "Bokmål norueguês - Noruega"
    },
    {
        "value": "Bósnio - Bósnia e Herzegovina",
        "label": "Bósnio - Bósnia e Herzegovina"
    },
    {
        "value": "Búlgaro - Bulgária",
        "label": "Búlgaro - Bulgária"
    },
    {
        "value": "Canarim - Índia",
        "label": "Canarim - Índia"
    },
    {
        "value": "Catalão - Espanha",
        "label": "Catalão - Espanha"
    },
    {
        "value": "Cazaque - Cazaquistão",
        "label": "Cazaque - Cazaquistão"
    },
    {
        "value": "Chinês - China",
        "label": "Chinês - China"
    },
    {
        "value": "Chinês - Hong Kong",
        "label": "Chinês - Hong Kong"
    },
    {
        "value": "Chinês - Singapura",
        "label": "Chinês - Singapura"
    },
    {
        "value": "Chinês - Taiwan",
        "label": "Chinês - Taiwan"
    },
    {
        "value": "Cingalês - Sri Lanka",
        "label": "Cingalês - Sri Lanka"
    },
    {
        "value": "Coreano - Coreia do Sul",
        "label": "Coreano - Coreia do Sul"
    },
    {
        "value": "Croata - Croácia",
        "label": "Croata - Croácia"
    },
    {
        "value": "Dinamarquês - Dinamarca",
        "label": "Dinamarquês - Dinamarca"
    },
    {
        "value": "Eslovaco - Eslováquia",
        "label": "Eslovaco - Eslováquia"
    },
    {
        "value": "Esloveno - Eslovênia",
        "label": "Esloveno - Eslovênia"
    },
    {
        "value": "Espanhol - Argentina",
        "label": "Espanhol - Argentina"
    },
    {
        "value": "Espanhol - Bolívia",
        "label": "Espanhol - Bolívia"
    },
    {
        "value": "Espanhol - Chile",
        "label": "Espanhol - Chile"
    },
    {
        "value": "Espanhol - Colômbia",
        "label": "Espanhol - Colômbia"
    },
    {
        "value": "Espanhol - Costa Rica",
        "label": "Espanhol - Costa Rica"
    },
    {
        "value": "Espanhol - El Salvador",
        "label": "Espanhol - El Salvador"
    },
    {
        "value": "Espanhol - Equador",
        "label": "Espanhol - Equador"
    },
    {
        "value": "Espanhol - Espanha",
        "label": "Espanhol - Espanha"
    },
    {
        "value": "Espanhol - Espanha",
        "label": "Espanhol - Espanha"
    },
    {
        "value": "Espanhol - Guatemala",
        "label": "Espanhol - Guatemala"
    },
    {
        "value": "Espanhol - Honduras",
        "label": "Espanhol - Honduras"
    },
    {
        "value": "Espanhol - México",
        "label": "Espanhol - México"
    },
    {
        "value": "Espanhol - Nicarágua",
        "label": "Espanhol - Nicarágua"
    },
    {
        "value": "Espanhol - Panamá",
        "label": "Espanhol - Panamá"
    },
    {
        "value": "Espanhol - Paraguai",
        "label": "Espanhol - Paraguai"
    },
    {
        "value": "Espanhol - Peru",
        "label": "Espanhol - Peru"
    },
    {
        "value": "Espanhol - Porto Rico",
        "label": "Espanhol - Porto Rico"
    },
    {
        "value": "Espanhol - República Dominicana",
        "label": "Espanhol - República Dominicana"
    },
    {
        "value": "Espanhol - Uruguai",
        "label": "Espanhol - Uruguai"
    },
    {
        "value": "Espanhol - Venezuela",
        "label": "Espanhol - Venezuela"
    },
    {
        "value": "Estoniano - Estônia",
        "label": "Estoniano - Estônia"
    },
    {
        "value": "Filipino - Filipinas",
        "label": "Filipino - Filipinas"
    },
    {
        "value": "Finlandês - Finlândia",
        "label": "Finlandês - Finlândia"
    },
    {
        "value": "Flamengo",
        "label": "Flamengo"
    },
    {
        "value": "Francês - Bélgica",
        "label": "Francês - Bélgica"
    },
    {
        "value": "Francês - Canadá",
        "label": "Francês - Canadá"
    },
    {
        "value": "Francês - França",
        "label": "Francês - França"
    },
    {
        "value": "Francês - Haiti",
        "label": "Francês - Haiti"
    },
    {
        "value": "Francês - Luxemburgo",
        "label": "Francês - Luxemburgo"
    },
    {
        "value": "Francês - Suíça",
        "label": "Francês - Suíça"
    },
    {
        "value": "Galego - Espanha",
        "label": "Galego - Espanha"
    },
    {
        "value": "Georgiano - Geórgia",
        "label": "Georgiano - Geórgia"
    },
    {
        "value": "Grego - Grécia",
        "label": "Grego - Grécia"
    },
    {
        "value": "Guzerate - Índia",
        "label": "Guzerate - Índia"
    },
    {
        "value": "Hauçá - Nigéria",
        "label": "Hauçá - Nigéria"
    },
    {
        "value": "Hebraico - Israel",
        "label": "Hebraico - Israel"
    },
    {
        "value": "Híndi - Índia",
        "label": "Híndi - Índia"
    },
    {
        "value": "Holandês - Países Baixos",
        "label": "Holandês - Países Baixos"
    },
    {
        "value": "Húngaro - Hungria",
        "label": "Húngaro - Hungria"
    },
    {
        "value": "Igbo - Nigéria",
        "label": "Igbo - Nigéria"
    },
    {
        "value": "Indonésio - Indonésia",
        "label": "Indonésio - Indonésia"
    },
    {
        "value": "Inglês - Austrália",
        "label": "Inglês - Austrália"
    },
    {
        "value": "Inglês - Belize",
        "label": "Inglês - Belize"
    },
    {
        "value": "Inglês - Canadá",
        "label": "Inglês - Canadá"
    },
    {
        "value": "Inglês - Chipre",
        "label": "Inglês - Chipre"
    },
    {
        "value": "Inglês - Estados Unidos",
        "label": "Inglês - Estados Unidos"
    },
    {
        "value": "Inglês - Gibraltar",
        "label": "Inglês - Gibraltar"
    },
    {
        "value": "Inglês - Irlanda",
        "label": "Inglês - Irlanda"
    },
    {
        "value": "Inglês - Malta",
        "label": "Inglês - Malta"
    },
    {
        "value": "Inglês - México",
        "label": "Inglês - México"
    },
    {
        "value": "Inglês - Nova Zelândia",
        "label": "Inglês - Nova Zelândia"
    },
    {
        "value": "Inglês - Países Baixos",
        "label": "Inglês - Países Baixos"
    },
    {
        "value": "Inglês - Reino Unido",
        "label": "Inglês - Reino Unido"
    },
    {
        "value": "Inglês - Singapura",
        "label": "Inglês - Singapura"
    },
    {
        "value": "Iorubá - Nigéria",
        "label": "Iorubá - Nigéria"
    },
    {
        "value": "Irlandês - Irlanda",
        "label": "Irlandês - Irlanda"
    },
    {
        "value": "Islandês - Islândia",
        "label": "Islandês - Islândia"
    },
    {
        "value": "Italiano - Itália",
        "label": "Italiano - Itália"
    },
    {
        "value": "Italiano - Suíça",
        "label": "Italiano - Suíça"
    },
    {
        "value": "Japonês - Japão",
        "label": "Japonês - Japão"
    },
    {
        "value": "Javanês - Indonésia",
        "label": "Javanês - Indonésia"
    },
    {
        "value": "Khmer - Camboja",
        "label": "Khmer - Camboja"
    },
    {
        "value": "Laosiano - Laos",
        "label": "Laosiano - Laos"
    },
    {
        "value": "Letão - Letônia",
        "label": "Letão - Letônia"
    },
    {
        "value": "Lituano - Lituânia",
        "label": "Lituano - Lituânia"
    },
    {
        "value": "Macedônio - Macedônia do Norte",
        "label": "Macedônio - Macedônia do Norte"
    },
    {
        "value": "Malaiala - Índia",
        "label": "Malaiala - Índia"
    },
    {
        "value": "Malaio - Malásia",
        "label": "Malaio - Malásia"
    },
    {
        "value": "Malaio - Singapura",
        "label": "Malaio - Singapura"
    },
    {
        "value": "Marati - Índia",
        "label": "Marati - Índia"
    },
    {
        "value": "Mongol - Mongólia",
        "label": "Mongol - Mongólia"
    },
    {
        "value": "Nepalês - Nepal",
        "label": "Nepalês - Nepal"
    },
    {
        "value": "Nynorsk norueguês - Noruega",
        "label": "Nynorsk norueguês - Noruega"
    },
    {
        "value": "Panjabi - Índia",
        "label": "Panjabi - Índia"
    },
    {
        "value": "Pashto - Afeganistão",
        "label": "Pashto - Afeganistão"
    },
    {
        "value": "Persa - Irã",
        "label": "Persa - Irã"
    },
    {
        "value": "Polonês - Polônia",
        "label": "Polonês - Polônia"
    },
    {
        "value": "Português - Brasil",
        "label": "Português - Brasil"
    },
    {
        "value": "Português - Portugal",
        "label": "Português - Portugal"
    },
    {
        "value": "Quirguiz - Quirguistão",
        "label": "Quirguiz - Quirguistão"
    },
    {
        "value": "Romeno - Romênia",
        "label": "Romeno - Romênia"
    },
    {
        "value": "Russo - Cazaquistão",
        "label": "Russo - Cazaquistão"
    },
    {
        "value": "Russo - Rússia",
        "label": "Russo - Rússia"
    },
    {
        "value": "Russo - Ucrânia",
        "label": "Russo - Ucrânia"
    },
    {
        "value": "Sérvio - Sérvia",
        "label": "Sérvio - Sérvia"
    },
    {
        "value": "Suaíli - Quênia",
        "label": "Suaíli - Quênia"
    },
    {
        "value": "Suaíli - Tanzânia",
        "label": "Suaíli - Tanzânia"
    },
    {
        "value": "Sueco - Suécia",
        "label": "Sueco - Suécia"
    },
    {
        "value": "Tadjique - Tadjiquistão",
        "label": "Tadjique - Tadjiquistão"
    },
    {
        "value": "Tailandês - Tailândia",
        "label": "Tailandês - Tailândia"
    },
    {
        "value": "Tâmil - Índia",
        "label": "Tâmil - Índia"
    },
    {
        "value": "Tâmil - Sri Lanka",
        "label": "Tâmil - Sri Lanka"
    },
    {
        "value": "Tcheco - Tchéquia",
        "label": "Tcheco - Tchéquia"
    },
    {
        "value": "Télugo - Índia",
        "label": "Télugo - Índia"
    },
    {
        "value": "Turco - Turquia",
        "label": "Turco - Turquia"
    },
    {
        "value": "Turcomeno - Turcomenistão",
        "label": "Turcomeno - Turcomenistão"
    },
    {
        "value": "Ucraniano - Ucrânia",
        "label": "Ucraniano - Ucrânia"
    },
    {
        "value": "Urdu - Índia",
        "label": "Urdu - Índia"
    },
    {
        "value": "Urdu - Paquistão",
        "label": "Urdu - Paquistão"
    },
    {
        "value": "Uzbeque - Uzbequistão",
        "label": "Uzbeque - Uzbequistão"
    },
    {
        "value": "Vietnamita - Vietnã",
        "label": "Vietnamita - Vietnã"
    },
    {
        "value": "Xhosa - África do Sul",
        "label": "Xhosa - África do Sul"
    },
    {
        "value": "Zulu - África do Sul",
        "label": "Zulu - África do Sul"
    }
];

export const CURRENCIES = [
    {
        "value": "EUR",
        "label": "EUR - Euro"
    },
    {
        "value": "AED",
        "label": "AED - Dirham dos Emirados Árabes Unidos"
    },
    {
        "value": "AFN",
        "label": "AFN - Afegane afegão"
    },
    {
        "value": "ALL",
        "label": "ALL - Lek albanês"
    },
    {
        "value": "AMD",
        "label": "AMD - Dram armênio"
    },
    {
        "value": "ANG",
        "label": "ANG - Florim das Antilhas Holandesas"
    },
    {
        "value": "AOA",
        "label": "AOA - Kwanza angolano"
    },
    {
        "value": "ARS",
        "label": "ARS - Peso argentino"
    },
    {
        "value": "AUD",
        "label": "AUD - Dólar australiano"
    },
    {
        "value": "AWG",
        "label": "AWG - Florim arubano"
    },
    {
        "value": "AZN",
        "label": "AZN - Manat azeri"
    },
    {
        "value": "BAM",
        "label": "BAM - Marco conversível da Bósnia e Herzegovina"
    },
    {
        "value": "BBD",
        "label": "BBD - Dólar barbadense"
    },
    {
        "value": "BDT",
        "label": "BDT - Taka bengali"
    },
    {
        "value": "BGN",
        "label": "BGN - Lev búlgaro"
    },
    {
        "value": "BHD",
        "label": "BHD - Dinar bareinita"
    },
    {
        "value": "BIF",
        "label": "BIF - Franco burundiano"
    },
    {
        "value": "BMD",
        "label": "BMD - Dólar bermudense"
    },
    {
        "value": "BND",
        "label": "BND - Dólar bruneano"
    },
    {
        "value": "BOB",
        "label": "BOB - Boliviano da Bolívia"
    },
    {
        "value": "BRL",
        "label": "BRL - Real brasileiro"
    },
    {
        "value": "BSD",
        "label": "BSD - Dólar bahamense"
    },
    {
        "value": "BTN",
        "label": "BTN - Ngultrum butanês"
    },
    {
        "value": "BWP",
        "label": "BWP - Pula botsuanesa"
    },
    {
        "value": "BYN",
        "label": "BYN - Rublo bielorrusso"
    },
    {
        "value": "BZD",
        "label": "BZD - Dólar belizenho"
    },
    {
        "value": "CAD",
        "label": "CAD - Dólar canadense"
    },
    {
        "value": "CDF",
        "label": "CDF - Franco congolês"
    },
    {
        "value": "CHF",
        "label": "CHF - Franco suíço"
    },
    {
        "value": "CLP",
        "label": "CLP - Peso chileno"
    },
    {
        "value": "CNY",
        "label": "CNY - Yuan chinês"
    },
    {
        "value": "COP",
        "label": "COP - Peso colombiano"
    },
    {
        "value": "CRC",
        "label": "CRC - Colón costarriquenho"
    },
    {
        "value": "CUC",
        "label": "CUC - Peso cubano conversível"
    },
    {
        "value": "CUP",
        "label": "CUP - Peso cubano"
    },
    {
        "value": "CVE",
        "label": "CVE - Escudo cabo-verdiano"
    },
    {
        "value": "CZK",
        "label": "CZK - Coroa tcheca"
    },
    {
        "value": "DJF",
        "label": "DJF - Franco djiboutiano"
    },
    {
        "value": "DKK",
        "label": "DKK - Coroa dinamarquesa"
    },
    {
        "value": "DOP",
        "label": "DOP - Peso dominicano"
    },
    {
        "value": "DZD",
        "label": "DZD - Dinar argelino"
    },
    {
        "value": "EGP",
        "label": "EGP - Libra egípcia"
    },
    {
        "value": "ERN",
        "label": "ERN - Nakfa da Eritreia"
    },
    {
        "value": "ETB",
        "label": "ETB - Birr etíope"
    },
    {
        "value": "EUR",
        "label": "EUR - Euro"
    },
    {
        "value": "FJD",
        "label": "FJD - Dólar fijiano"
    },
    {
        "value": "FKP",
        "label": "FKP - Libra malvinense"
    },
    {
        "value": "GBP",
        "label": "GBP - Libra esterlina"
    },
    {
        "value": "GEL",
        "label": "GEL - Lari georgiano"
    },
    {
        "value": "GHS",
        "label": "GHS - Cedi ganês"
    },
    {
        "value": "GIP",
        "label": "GIP - Libra de Gibraltar"
    },
    {
        "value": "GMD",
        "label": "GMD - Dalasi gambiano"
    },
    {
        "value": "GNF",
        "label": "GNF - Franco guineano"
    },
    {
        "value": "GTQ",
        "label": "GTQ - Quetzal guatemalteco"
    },
    {
        "value": "GYD",
        "label": "GYD - Dólar guianense"
    },
    {
        "value": "HKD",
        "label": "HKD - Dólar de Hong Kong"
    },
    {
        "value": "HNL",
        "label": "HNL - Lempira hondurenha"
    },
    {
        "value": "HRK",
        "label": "HRK - Kuna croata"
    },
    {
        "value": "HTG",
        "label": "HTG - Gourde haitiano"
    },
    {
        "value": "HUF",
        "label": "HUF - Florim húngaro"
    },
    {
        "value": "IDR",
        "label": "IDR - Rupia indonésia"
    },
    {
        "value": "ILS",
        "label": "ILS - Novo shekel israelense"
    },
    {
        "value": "INR",
        "label": "INR - Rupia indiana"
    },
    {
        "value": "IQD",
        "label": "IQD - Dinar iraquiano"
    },
    {
        "value": "IRR",
        "label": "IRR - Rial iraniano"
    },
    {
        "value": "ISK",
        "label": "ISK - Coroa islandesa"
    },
    {
        "value": "JMD",
        "label": "JMD - Dólar jamaicano"
    },
    {
        "value": "JOD",
        "label": "JOD - Dinar jordaniano"
    },
    {
        "value": "JPY",
        "label": "JPY - Iene japonês"
    },
    {
        "value": "KES",
        "label": "KES - Xelim queniano"
    },
    {
        "value": "KGS",
        "label": "KGS - Som quirguiz"
    },
    {
        "value": "KHR",
        "label": "KHR - Riel cambojano"
    },
    {
        "value": "KMF",
        "label": "KMF - Franco comoriano"
    },
    {
        "value": "KPW",
        "label": "KPW - Won norte-coreano"
    },
    {
        "value": "KRW",
        "label": "KRW - Won sul-coreano"
    },
    {
        "value": "KWD",
        "label": "KWD - Dinar kuwaitiano"
    },
    {
        "value": "KYD",
        "label": "KYD - Dólar das Ilhas Cayman"
    },
    {
        "value": "KZT",
        "label": "KZT - Tenge cazaque"
    },
    {
        "value": "LAK",
        "label": "LAK - Kip laosiano"
    },
    {
        "value": "LBP",
        "label": "LBP - Libra libanesa"
    },
    {
        "value": "LKR",
        "label": "LKR - Rupia cingalesa"
    },
    {
        "value": "LRD",
        "label": "LRD - Dólar liberiano"
    },
    {
        "value": "LSL",
        "label": "LSL - Loti lesotiano"
    },
    {
        "value": "LYD",
        "label": "LYD - Dinar líbio"
    },
    {
        "value": "MAD",
        "label": "MAD - Dirham marroquino"
    },
    {
        "value": "MDL",
        "label": "MDL - Leu moldávio"
    },
    {
        "value": "MGA",
        "label": "MGA - Ariary malgaxe"
    },
    {
        "value": "MKD",
        "label": "MKD - Dinar macedônio"
    },
    {
        "value": "MMK",
        "label": "MMK - Quiate mianmarense"
    },
    {
        "value": "MNT",
        "label": "MNT - Tugrik mongol"
    },
    {
        "value": "MOP",
        "label": "MOP - Pataca macaense"
    },
    {
        "value": "MRU",
        "label": "MRU - Ouguiya mauritana"
    },
    {
        "value": "MUR",
        "label": "MUR - Rupia mauriciana"
    },
    {
        "value": "MVR",
        "label": "MVR - Rupia maldivana"
    },
    {
        "value": "MWK",
        "label": "MWK - Kwacha malauiana"
    },
    {
        "value": "MXN",
        "label": "MXN - Peso mexicano"
    },
    {
        "value": "MYR",
        "label": "MYR - Ringgit malaio"
    },
    {
        "value": "MZN",
        "label": "MZN - Metical moçambicano"
    },
    {
        "value": "NAD",
        "label": "NAD - Dólar namibiano"
    },
    {
        "value": "NGN",
        "label": "NGN - Naira nigeriana"
    },
    {
        "value": "NIO",
        "label": "NIO - Córdoba nicaraguense"
    },
    {
        "value": "NOK",
        "label": "NOK - Coroa norueguesa"
    },
    {
        "value": "NPR",
        "label": "NPR - Rupia nepalesa"
    },
    {
        "value": "NZD",
        "label": "NZD - Dólar neozelandês"
    },
    {
        "value": "OMR",
        "label": "OMR - Rial omanense"
    },
    {
        "value": "PAB",
        "label": "PAB - Balboa panamenho"
    },
    {
        "value": "PEN",
        "label": "PEN - Novo sol peruano"
    },
    {
        "value": "PGK",
        "label": "PGK - Kina papuásia"
    },
    {
        "value": "PHP",
        "label": "PHP - Peso filipino"
    },
    {
        "value": "PKR",
        "label": "PKR - Rupia paquistanesa"
    },
    {
        "value": "PLN",
        "label": "PLN - Zloty polonês"
    },
    {
        "value": "PYG",
        "label": "PYG - Guarani paraguaio"
    },
    {
        "value": "QAR",
        "label": "QAR - Rial catariano"
    },
    {
        "value": "RON",
        "label": "RON - Leu romeno"
    },
    {
        "value": "RSD",
        "label": "RSD - Dinar sérvio"
    },
    {
        "value": "RUB",
        "label": "RUB - Rublo russo"
    },
    {
        "value": "RWF",
        "label": "RWF - Franco ruandês"
    },
    {
        "value": "SAR",
        "label": "SAR - Riyal saudita"
    },
    {
        "value": "SBD",
        "label": "SBD - Dólar das Ilhas Salomão"
    },
    {
        "value": "SCR",
        "label": "SCR - Rupia seichelense"
    },
    {
        "value": "SDG",
        "label": "SDG - Libra sudanesa"
    },
    {
        "value": "SEK",
        "label": "SEK - Coroa sueca"
    },
    {
        "value": "SGD",
        "label": "SGD - Dólar singapuriano"
    },
    {
        "value": "SHP",
        "label": "SHP - Libra de Santa Helena"
    },
    {
        "value": "SLL",
        "label": "SLL - Leone de Serra Leoa (1964—2022)"
    },
    {
        "value": "SOS",
        "label": "SOS - Xelim somali"
    },
    {
        "value": "SRD",
        "label": "SRD - Dólar surinamês"
    },
    {
        "value": "SSP",
        "label": "SSP - Libra sul-sudanesa"
    },
    {
        "value": "STN",
        "label": "STN - Dobra de São Tomé e Príncipe"
    },
    {
        "value": "SVC",
        "label": "SVC - Colom salvadorenho"
    },
    {
        "value": "SYP",
        "label": "SYP - Libra síria"
    },
    {
        "value": "SZL",
        "label": "SZL - Lilangeni suazi"
    },
    {
        "value": "THB",
        "label": "THB - Baht tailandês"
    },
    {
        "value": "TJS",
        "label": "TJS - Somoni tadjique"
    },
    {
        "value": "TMT",
        "label": "TMT - Manat turcomeno"
    },
    {
        "value": "TND",
        "label": "TND - Dinar tunisiano"
    },
    {
        "value": "TOP",
        "label": "TOP - Paʻanga tonganesa"
    },
    {
        "value": "TRY",
        "label": "TRY - Lira turca"
    },
    {
        "value": "TTD",
        "label": "TTD - Dólar de Trinidad e Tobago"
    },
    {
        "value": "TWD",
        "label": "TWD - Novo dólar taiwanês"
    },
    {
        "value": "TZS",
        "label": "TZS - Xelim tanzaniano"
    },
    {
        "value": "UAH",
        "label": "UAH - Hryvnia ucraniano"
    },
    {
        "value": "UGX",
        "label": "UGX - Xelim ugandense"
    },
    {
        "value": "USD",
        "label": "USD - Dólar americano"
    },
    {
        "value": "UYU",
        "label": "UYU - Peso uruguaio"
    },
    {
        "value": "UZS",
        "label": "UZS - Som uzbeque"
    },
    {
        "value": "VES",
        "label": "VES - Bolívar venezuelano"
    },
    {
        "value": "VND",
        "label": "VND - Dong vietnamita"
    },
    {
        "value": "VUV",
        "label": "VUV - Vatu de Vanuatu"
    },
    {
        "value": "WST",
        "label": "WST - Tala samoano"
    },
    {
        "value": "XAF",
        "label": "XAF - Franco CFA de BEAC"
    },
    {
        "value": "XCD",
        "label": "XCD - Dólar do Caribe Oriental"
    },
    {
        "value": "XDR",
        "label": "XDR - Direitos Especiais de Giro"
    },
    {
        "value": "XOF",
        "label": "XOF - Franco CFA de BCEAO"
    },
    {
        "value": "XPF",
        "label": "XPF - Franco CFP"
    },
    {
        "value": "XSU",
        "label": "XSU - XSU"
    },
    {
        "value": "YER",
        "label": "YER - Rial iemenita"
    },
    {
        "value": "ZAR",
        "label": "ZAR - Rand sul-africano"
    },
    {
        "value": "ZMW",
        "label": "ZMW - Kwacha zambiano"
    },
    {
        "value": "ZWL",
        "label": "ZWL - Dólar do Zimbábue (2009)"
    }
];
